import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { resetForm } from "../Functions/Utilities";
import { Input, TextArea } from "../Components/Form/Form";

export default function CaseReportForms({
  selectedCase,
  firms,
  setSuccess,
  setError,
  setCases,
  setSelectedCase,
  handleSubmit,
  handleCaseDelete,
  setDomains,
  setIsLoading
}) {
  const [selectedTab, setSelectedTab] = useState(null);

  const handleTabChange = (event) => {
    if (selectedTab === event.target.getAttribute("data-key")) {
      setSelectedTab(null);
    } else {
      const key = event.target.getAttribute("data-key");
      setSelectedTab(key);
    }
  };

  return (
    <div>
      <h5 className="uppercase text-[#ef8d23] font-bold">Case Details</h5>
      <div className="mb-4 flex sm:flex-col">
        <button
          className={`border py-1 px-3 ${
            selectedTab === "general" ? "bg-[#ef8d23] text-white" : ""
          }`}
          onClick={handleTabChange}
          data-key="general"
        >
          General
        </button>
        <button
          className={`border xl:ml-3 xs:ml-0 py-1 px-3 ${
            selectedTab === "commencement" ? "bg-[#ef8d23] text-white" : ""
          }`}
          onClick={handleTabChange}
          data-key="commencement"
        >
          Commencement
        </button>
        <button
          className={`border xl:ml-3 xs:ml-0 py-1 px-3 ${
            selectedTab === "respext" ? "bg-[#ef8d23] text-white" : ""
          }`}
          onClick={handleTabChange}
          data-key="respext"
        >
          Response Extension
        </button>
        <button
          className={`border xl:ml-3 xs:ml-0 py-1 px-3 ${
            selectedTab === "settlement" ? "bg-[#ef8d23] text-white" : ""
          }`}
          onClick={handleTabChange}
          data-key="settlement"
        >
          Settlement
        </button>
        <button
          className={`border xl:ml-3 xs:ml-0 py-1 px-3 ${
            selectedTab === "resp" ? "bg-[#ef8d23] text-white" : ""
          }`}
          onClick={handleTabChange}
          data-key="resp"
        >
          Response
        </button>
        <button
          className={`border xl:ml-3 xs:ml-0 py-1 px-3 ${
            selectedTab === "reply" ? "bg-[#ef8d23] text-white" : ""
          }`}
          onClick={handleTabChange}
          data-key="reply"
        >
          Reply
        </button>
      </div>

      <div className="pr-5">
        {selectedTab && selectedTab === "general" && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              casenumber: selectedCase.casenumber,
              complainantlc: selectedCase.complainantlc,
              complainant: selectedCase.complainant,
              complainantemail: selectedCase.complainantemail,
              casedate: selectedCase.casedate,
              registrant: selectedCase.registrant,
              registrantemail: selectedCase.registrantemail,
              rt: selectedCase.rt,
              active: selectedCase.active,
            }}
            validationSchema={Yup.object().shape({
              casenumber: Yup.string().required("Field is required."),
              complainantlc: Yup.number().required("Field is required."),
              complainant: Yup.string().required("Field is required."),
              complainantemail: Yup.string().email().required("Field is required."),
              casedate: Yup.date().required("Field is required."),
              registrant: Yup.string().required("Field is required."),
              registrantemail: Yup.string().email().required("Field is required."),
              rt: Yup.number().required("Field is required.")

            })}
            onSubmit={async (values, actions) => {
              await new Promise((r) =>
                handleSubmit(
                  values,
                  setSuccess,
                  setError,
                  selectedCase,
                  setSelectedCase,
                  setCases,
                  setIsLoading
                )
              );

              resetForm(actions);
            }}
          >
            {({ isSubmitting, status }) => (
              <Form>
                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Case Number
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  type="text"
                  name="casenumber"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Case Lodgement Date
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  type="date"
                  name="casedate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>
                <div className="mb-[8px]">
                  Complainant Legal Council
                  <span className="text-[#fb4f58]">*</span>
                </div>
                <Field
                  as="select"
                  name="complainantlc"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="None">None</option>
                  {firms.map((firm) => (
                    <option value={firm.firmid}>{firm.firm}</option>
                  ))}
                </Field>
                <Input
                  data-test="cases-update-input"
                  showErrorMsg={true}
                  name="complainant"
                  type="text"
                  labelClass="mb-[10px]"
                  label={
                    <div className="my-[8px]">
                      Complainant
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                  placeholder="Enter the case complainant"
                />
                <Input
                  data-test="cases-update-input"
                  showErrorMsg={true}
                  name="complainantemail"
                  type="text"
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Complainant Email
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                  placeholder="Enter complainant's email"
                />
                <Input
                  data-test="cases-update-input"
                  showErrorMsg={true}
                  name="registrant"
                  type="text"
                  labelClass="mb-[10px]"
                  label={
                    <div className="my-[8px]">
                      Registrant
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                  placeholder="Enter the case registrant"
                />
                <Input
                  data-test="cases-update-input"
                  showErrorMsg={true}
                  name="registrantemail"
                  type="text"
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Registrant Email
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                  placeholder="Enter registrant's email"
                />
                <Input
                  data-test="cases-update-input"
                  showErrorMsg={true}
                  name="rt"
                  type="text"
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Case Reference Number
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                  placeholder="Enter reference number"
                />

                <div className="flex justify-content-between">
                  <button
                    type="submit"
                    className="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                  >
                    Update
                  </button>
                  <button
                    onClick={() =>
                      handleCaseDelete(
                        selectedCase,
                        setCases,
                        setDomains,
                        setError,
                        setSuccess,
                        setSelectedCase,
                        setIsLoading,

                      )
                    }
                    className="mt-3 text-white bg-[#dc3545] py-1 px-3 hover:bg-[#dc3545cc]"
                    type="button"
                  >
                    Delete
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}

        {selectedTab && selectedTab === "commencement" && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              paymentreqdate: selectedCase.paymentreqdate,
              paymentnotdate: selectedCase.paymentnotdate,
              adjpanelreq: selectedCase.adjpanelreq,
              susprdate: selectedCase.susprdate,
              suspdate: selectedCase.suspdate,
              registryrt: selectedCase.registryrt,
              disputedeficient: selectedCase.disputedeficient,
              dispnotdate: selectedCase.dispnotdate,
              dispdefcompld: selectedCase.dispdefcompld,
              dispdefdtls: selectedCase.dispdefdtls,
              responsedld: selectedCase.responsedld,
              registrantemail: selectedCase.registrantemail,
              defcomplyd: selectedCase.defcomplyd,
              registrantlc: selectedCase.registrantlc,
              commdate: selectedCase.commdate,
            }}
            validationSchema={Yup.object().shape({
              
              registrantemail: Yup.string().email().required("Field is required."),
            })}
            onSubmit={async (values, actions) => {
              await new Promise((r) =>
                handleSubmit(
                  values,
                  setSuccess,
                  setError,
                  selectedCase,
                  setSelectedCase,
                  setCases
                )
              );

              resetForm(actions);
            }}
          >
            {({ isSubmitting, status }) => (
              <Form>
                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Payment Request Date</div>}
                  type="date"
                  name="paymentreqdate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Payment Confirmation Date

                    </div>
                  }
                  type="date"
                  name="paymentnotdate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>
                <div className="mb-[8px]">
                  Adjudicator Panel

                </div>
                <Field
                  as="select"
                  name="adjpanelreq"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value=""></option>
                  <option value="1">1</option>
                  <option value="3">3</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">Suspension Request Date</div>
                  }
                  type="date"
                  name="susprdate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Suspension Date</div>}
                  type="date"
                  name="suspdate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  data-test="cases-update-input"
                  showErrorMsg={true}
                  name="registryrt"
                  type="number"
                  labelClass="mb-[10px]"
                  label={
                    <div className="my-[8px]">
                      Reference Number
                      <span className="text-[#fb4f58]">*</span>
                    </div>
                  }
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                  placeholder="Enter the case reference number"
                />
                <div className="mb-[8px]">
                  Dispute Deficient

                </div>
                <Field
                  as="select"
                  name="disputedeficient"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">Dispute Deficient Not. Date</div>
                  }
                  type="date"
                  name="dispnotdate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Dispute Deficient Compliance Date
                    </div>
                  }
                  type="date"
                  name="dispdefcompld"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <TextArea
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">Dispute Deficient Details</div>
                  }
                  type="text"
                  name="dispdefdtls"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                />

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Commencement Notification Date
                    </div>
                  }
                  type="date"
                  name="commdate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Response Deadline</div>}
                  type="date"
                  name="responsedld"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Registrant Email</div>}
                  type="text"
                  name="registrantemail"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="mb-[8px]">
                  Registrant Legal Council

                </div>
                <Field
                  as="select"
                  name="registrantlc"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  {firms.map((firm) => (
                    <option value={firm.firmid}>{firm.firm}</option>
                  ))}
                </Field>

                <div className="flex justify-content-between">
                  <button
                    type="submit"
                    className="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                  >
                    Update
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}

        {selectedTab && selectedTab === "respext" && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              extension: selectedCase.extension,
              extdr: selectedCase.extdr,
              extdet: selectedCase.extdet,
              extcdl: selectedCase.extcdl,
              extnoticedate: selectedCase.extnoticedate,
            }}
            onSubmit={async (values, actions) => {
              await new Promise((r) =>
                handleSubmit(
                  values,
                  setSuccess,
                  setError,
                  selectedCase,
                  setSelectedCase,
                  setCases
                )
              );

              resetForm(actions);
            }}
          >
            {({ isSubmitting, status }) => (
              <Form>
                <div className="mb-[8px]">
                  Extension
                </div>
                <Field
                  as="select"
                  name="extension"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Requested On</div>}
                  type="date"
                  name="extdr"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <TextArea
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Extension Details</div>}
                  type="text"
                  name="extdet"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                />

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      New Response Deadline
                    </div>
                  }
                  type="date"
                  name="extcdl"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Extension Notice Date</div>}
                  type="date"
                  name="extnoticedate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="flex justify-content-between">
                  <button
                    type="submit"
                    className="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                  >
                    Update
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
        {selectedTab && selectedTab === "settlement" && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              posettlenotd: selectedCase.posettlenotd,
              settleagreedl: selectedCase.settleagreedl,
              settled: selectedCase.settled,
              settleagreerecd: selectedCase.settleagreerecd,
              settledate: selectedCase.settledate,
            }}
            onSubmit={async (values, actions) => {
              await new Promise((r) =>
                handleSubmit(
                  values,
                  setSuccess,
                  setError,
                  selectedCase,
                  setSelectedCase,
                  setCases
                )
              );

              resetForm(actions);
            }}
          >
            {({ isSubmitting, status }) => (
              <Form>
                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Possible Settlement Notification Date
                    </div>
                  }
                  type="date"
                  name="posettlenotd"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Settlement Agreement Deadline
                    </div>
                  }
                  type="date"
                  name="settleagreedl"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="mb-[8px]">
                  Settled
                </div>
                <Field
                  as="select"
                  name="settled"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Settlement Agreement Received On
                    </div>
                  }
                  type="date"
                  name="settleagreerecd"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Settle Date</div>}
                  type="date"
                  name="settledate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="flex justify-content-between">
                  <button
                    type="submit"
                    className="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                  >
                    Update
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
        {selectedTab && selectedTab === "resp" && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              respdefault: selectedCase.respdefault,
              respdefnotd: selectedCase.respdefnotd,
              respdeficient: selectedCase.respdeficient,
              respdefdl: selectedCase.respdefdl,
              respdefnd: selectedCase.respdefnd,
              respdefdet: selectedCase.respdefdet,
              resprec: selectedCase.resprec,
              respdate: selectedCase.respdate,
            }}
            onSubmit={async (values, actions) => {
              await new Promise((r) =>
                handleSubmit(
                  values,
                  setSuccess,
                  setError,
                  selectedCase,
                  setSelectedCase,
                  setCases
                )
              );

              resetForm(actions);
            }}
          >
            {({ isSubmitting, status }) => (
              <Form>
                <div className="mb-[8px]">
                  Response Default
                </div>
                <Field
                  as="select"
                  name="respdefault"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Response Default Notification Date
                    </div>
                  }
                  type="date"
                  name="respdefnotd"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="mb-[8px]">
                  Response Deficient
                </div>
                <Field
                  as="select"
                  name="respdeficient"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Response Deficiency Deadline
                    </div>
                  }
                  type="date"
                  name="respdefdl"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Response Deficiency Notification Date
                    </div>
                  }
                  type="date"
                  name="respdefnd"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <TextArea
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">Response Deficiency Details</div>
                  }
                  type="text"
                  name="respdefdet"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                />

                <div className="mb-[8px]">
                  Response Received
                </div>
                <Field
                  as="select"
                  name="resprec"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Response Received Date</div>}
                  type="date"
                  name="respdate"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="flex justify-content-between">
                  <button
                    type="submit"
                    className="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                  >
                    Update
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
        {selectedTab && selectedTab === "reply" && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              replydl: selectedCase.replydl,
              replyextension: selectedCase.replyextension,
              repextrqdt: selectedCase.repextrqdt,
              repextdldt: selectedCase.repextdldt,
              replxnotd: selectedCase.replxnotd,
              repextdet: selectedCase.repextdet,
              replydefault: selectedCase.replydefault,
              replydefaultd: selectedCase.replydefaultd,
              replydeficient: selectedCase.replydeficient,
              replydeficientnd: selectedCase.replydeficientnd,
              replydefdl: selectedCase.replydefdl,
              replydeficientdet: selectedCase.replydeficientdet,
              replyreceived: selectedCase.replyreceived,
              replyrecdt: selectedCase.replyrecdt,
            }}
            onSubmit={async (values, actions) => {
              await new Promise((r) =>
                handleSubmit(
                  values,
                  setSuccess,
                  setError,
                  selectedCase,
                  setSelectedCase,
                  setCases
                )
              );

              resetForm(actions);
            }}
          >
            {({ isSubmitting, status }) => (
              <Form>
                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Reply Deadline</div>}
                  type="date"
                  name="replydl"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="mb-[8px]">
                  Reply Extension
                </div>
                <Field
                  as="select"
                  name="replyextension"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">Reply Extension Request Date</div>
                  }
                  type="date"
                  name="repextrqdt"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Reply Extension Deadline Date
                    </div>
                  }
                  type="date"
                  name="repextdldt"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Reply Extension Notification Date
                    </div>
                  }
                  type="date"
                  name="replxnotd"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <TextArea
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">Reply Extension Details</div>
                  }
                  type="text"
                  name="repextdet"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                />

                <div className="mb-[8px]">
                  Reply Default
                </div>
                <Field
                  as="select"
                  name="replydefault"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Reply Default Notification Date
                    </div>
                  }
                  type="date"
                  name="replydefaultd"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="mb-[8px]">
                  Reply Deficient
                </div>
                <Field
                  as="select"
                  name="replydeficient"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Reply Deficient Deadline
                    </div>
                  }
                  type="date"
                  name="replydefdl"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <Input
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">
                      Reply Deficiency Notification Date
                    </div>
                  }
                  type="date"
                  name="replydeficientnd"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <TextArea
                  labelClass="mb-[10px]"
                  label={
                    <div className="mb-[8px]">Reply Deficiency Details</div>
                  }
                  type="text"
                  name="replydeficientdet"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                />

                <div className="mb-[8px]">
                  Reply Received
                </div>
                <Field
                  as="select"
                  name="replyreceived"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Field>

                <Input
                  labelClass="mb-[10px]"
                  label={<div className="mb-[8px]">Reply Received Date</div>}
                  type="date"
                  name="replyrecdt"
                  className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                ></Input>

                <div className="flex justify-content-between">
                  <button
                    type="submit"
                    className="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                  >
                    Update
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </div>
  );
}
